if (!customElements.get('cart-crosssell')) {
  customElements.define(
    'cart-crosssell',
    class extends HTMLElement {
      connectedCallback() {
        this.wrapper = this.querySelector('.cs-wrapper');
        this.carousel = this.querySelector('.cs-carousel');
        this.container = this.querySelector('.cs-track-container');
        this.track = this.querySelector('.cs-track');
        this.dots = this.querySelector('.cs-dots');
        this.prevBtn = this.querySelector('.cs-arrow--prev');
        this.nextBtn = this.querySelector('.cs-arrow--next');

        this.current = 0;
        this.cards = Array.from(this.track ? this.track.querySelectorAll('.cs-card') : []);

        this.cards.forEach((card) => this.bindCard(card));

        requestAnimationFrame(() => this.equalizeHeights());
        this.watchHeights();

        if (this.cards.length > 1) {
          this.carousel.classList.add('has-arrows');

          if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.goTo(this.current - 1));
          if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.goTo(this.current + 1));

          if (this.dots) {
            this.dots.querySelectorAll('.cs-dot').forEach((dot) => {
              dot.addEventListener('click', () => this.goTo(parseInt(dot.dataset.index, 10)));
            });
          }

          this.setupDrag();
        }

        this.updateUI();
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.onResize) window.removeEventListener('resize', this.onResize);
      }

      /**
       * Liga o seletor de variante (se houver) e o botão de adicionar de um card.
       * O card já vem pronto do servidor (renderizado via Liquid), então aqui só
       * precisamos ligar os eventos.
       */
      bindCard(card) {
        const select = card.querySelector('[data-variant-select]');
        const variantInput = card.querySelector('.cs-variant-id');
        const priceDisplay = card.querySelector('[data-price-display]');

        if (select) {
          select.addEventListener('change', () => {
            const option = select.selectedOptions[0];
            if (!option) return;
            variantInput.value = option.value;
            if (priceDisplay && option.dataset.priceFormatted) {
              priceDisplay.textContent = option.dataset.priceFormatted;
            }
          });
        }

        const btn = card.querySelector('.cs-btn[data-action="add-to-cart"]');
        if (!btn || btn.disabled) return;

        btn.addEventListener('click', async () => {
          if (btn.disabled) return;

          const variantId = variantInput.value;
          const btnText = btn.querySelector('.cs-btn-text');
          const btnLoad = btn.querySelector('.cs-btn-loading');
          const btnSuccess = btn.querySelector('.cs-btn-success');

          btn.disabled = true;
          if (btnText) btnText.style.display = 'none';
          if (btnLoad) btnLoad.style.display = 'flex';

          try {
            const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({
                id: parseInt(variantId, 10),
                quantity: 1,
                // Marca a origem da linha, mesma convenção do assets/cart-upgrade.js.
                // O prefixo "_" faz o Shopify esconder a propriedade do cliente no
                // carrinho, checkout e e-mails; ela continua visivel no Admin, no
                // detalhe da linha do pedido.
                // Aqui vai na mesma requisicao porque /cart/add.js aceita properties
                // (ao contrario de /cart/update.js, que so aceita quantidades).
                properties: { _added_via: 'cart-crosssell' },
                sections: 'cart-drawer,cart-icon-bubble',
              }),
            });

            if (!res.ok) throw new Error('Erro ao adicionar ao carrinho');
            const parsedState = await res.json();

            if (btnLoad) btnLoad.style.display = 'none';
            if (btnSuccess) btnSuccess.style.display = 'block';
            btn.classList.add('cs-success');

            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
              cartDrawer.renderContents(parsedState);
            } else {
              window.location.reload();
            }
          } catch (error) {
            if (btnLoad) btnLoad.style.display = 'none';
            if (btnText) btnText.style.display = '';
            btn.disabled = false;
          }
        });
      }

      /* Trava a altura do trilho na do card mais alto, pra não ficar tremendo entre cards. */
      equalizeHeights() {
        if (!this.cards.length || !this.track) return;

        this.track.style.height = 'auto';
        this.cards.forEach((c) => {
          c.style.height = 'auto';
        });

        let max = 0;
        this.cards.forEach((c) => {
          const h = c.getBoundingClientRect().height;
          if (h > max) max = h;
        });

        if (max > 0) {
          const px = Math.ceil(max) + 'px';
          this.track.style.height = px;
          this.cards.forEach((c) => {
            c.style.height = px;
          });
        }
      }

      watchHeights() {
        this.querySelectorAll('.cs-img').forEach((img) => {
          if (!img.complete) {
            img.addEventListener('load', () => this.equalizeHeights(), { once: true });
            img.addEventListener('error', () => this.equalizeHeights(), { once: true });
          }
        });

        let raf = null;
        this.onResize = () => {
          if (raf) cancelAnimationFrame(raf);
          raf = requestAnimationFrame(() => this.equalizeHeights());
        };
        window.addEventListener('resize', this.onResize);

        if (window.ResizeObserver && this.container) {
          this.resizeObserver = new ResizeObserver(this.onResize);
          this.resizeObserver.observe(this.container);
        }
      }

      setupDrag() {
        if (!this.container || !this.track) return;

        let active = false;
        let decided = false;
        let horizontal = false;
        let pointerId = null;
        let startX = 0;
        let startY = 0;
        let delta = 0;
        let moved = false;

        const reset = () => {
          active = false;
          decided = false;
          horizontal = false;
          pointerId = null;
          delta = 0;
          this.container.classList.remove('is-dragging');
        };

        this.container.addEventListener('pointerdown', (e) => {
          if (e.pointerType === 'mouse' && e.button !== 0) return;
          if (this.cards.length <= 1) return;
          if (e.target.closest('.cs-btn, .cs-variant-select')) return;

          active = true;
          decided = false;
          horizontal = false;
          moved = false;
          pointerId = e.pointerId;
          startX = e.clientX;
          startY = e.clientY;
          delta = 0;
        });

        this.container.addEventListener('pointermove', (e) => {
          if (!active || e.pointerId !== pointerId) return;

          const mx = e.clientX - startX;
          const my = e.clientY - startY;

          if (!decided) {
            if (Math.abs(mx) < 6 && Math.abs(my) < 6) return;
            decided = true;
            horizontal = Math.abs(mx) > Math.abs(my);

            if (horizontal) {
              moved = true;
              this.container.setPointerCapture(pointerId);
              this.container.classList.add('is-dragging');
            } else {
              active = false;
              return;
            }
          }

          if (!horizontal) return;

          delta = mx;
          const atStart = this.current === 0 && delta > 0;
          const atEnd = this.current === this.cards.length - 1 && delta < 0;
          if (atStart || atEnd) delta *= 0.3;

          this.track.style.transform = `translateX(calc(${-this.current * 100}% + ${delta}px))`;
        });

        const finish = (e) => {
          if (!active || (pointerId !== null && e.pointerId !== pointerId)) return;

          const shouldMove = horizontal && Math.abs(delta) > 50;
          const dir = delta < 0 ? 1 : -1;
          const target = shouldMove ? this.current + dir : this.current;

          reset();
          this.goTo(target);
        };

        this.container.addEventListener('pointerup', finish);
        this.container.addEventListener('pointercancel', () => {
          if (!active) return;
          reset();
          this.goTo(this.current);
        });

        this.container.addEventListener(
          'click',
          (e) => {
            if (moved) {
              e.preventDefault();
              e.stopPropagation();
              moved = false;
            }
          },
          true
        );

        this.container.addEventListener('dragstart', (e) => e.preventDefault());
      }

      updateUI() {
        if (this.dots) {
          this.dots.querySelectorAll('.cs-dot').forEach((dot, index) => {
            dot.classList.toggle('is-active', index === this.current);
          });
        }
        if (this.prevBtn) this.prevBtn.disabled = this.current === 0;
        if (this.nextBtn) this.nextBtn.disabled = this.current === this.cards.length - 1;
      }

      goTo(idx) {
        if (!this.track) return;
        this.current = Math.max(0, Math.min(idx, this.cards.length - 1));
        this.track.style.transform = `translateX(-${this.current * 100}%)`;
        this.updateUI();
      }
    }
  );
}
